import { Component, inject } from '@angular/core';
import { MatDialogRef, MatDialogTitle } from '@angular/material/dialog';

@Component({
    selector: 'app-dialog-refresh-app',
    templateUrl: './dialog-refresh-app.component.html',
    styleUrls: ['./dialog-refresh-app.component.scss'],
    imports: [MatDialogTitle]
})
export class DialogRefreshAppComponent {
    private readonly dialogRef = inject<MatDialogRef<DialogRefreshAppComponent>>(MatDialogRef);


    dismiss() {
        this.dialogRef.close();
    }
}
